<template>
	<div>
		<v-layout align-center justify-center class="dataLoading">
			<v-progress-circular
				indeterminate
				color="primary"
				v-show="loadingData"
			/>
		</v-layout>

		<bls-seepass-filter
			@submit="submit"
			@submitExcel="submitExcel"
		/>

		<bls-seepass-table
			:blsSeepassData="tableContents"
		/>
	</div>
</template>
<script>
import axios from 'axios'
import BlsSeepassTable from './blsSeepassTable.vue'
import BlsSeepassFilter from './blsSeepassFilter.vue'

export default {
	components: { BlsSeepassTable, BlsSeepassFilter },
	name: 'BlsSeepassReport',
	data() {
		return {
			tableContents: [],
			loadingData: false,
		}
	},
	methods: {
		async submit(filters) {
			this.loadingData = true
			try {
				// eslint-disable-next-line no-undef
				const res = await axios.post(`${config.baseAPIurl}/bls-seepass-report`, filters)
				this.tableContents = res.data
			} catch (err) {
				console.log(err)
			} finally {
				this.loadingData = false
			}
		},
		async submitExcel(filters) {
			this.loadingData = true
			try {
				// eslint-disable-next-line no-undef
				const response = await axios({
					method: 'post',
					// eslint-disable-next-line no-undef
					url: `${config.baseAPIurl}/bls-seepass-report/excel`,
					data: filters,
					responseType: 'blob',
				})
				// eslint-disable-next-line no-undef
				let filenameExtension
				if (filters.dateFrom === filters.dateTill) {
					filenameExtension = filters.dateFrom
				} else {
					filenameExtension = `${filters.dateFrom}-${filters.dateTill}`
				}
				saveAs(new Blob([response.data]), `seepass_report_${filenameExtension}.xlsx`)
				// this.tableContents = res.data
			} catch (err) {
				console.log(err)
			} finally {
				this.loadingData = false
			}
		}
	},
}
</script>

<style scoped>

.dataLoading {
	padding-top: 11px;
}

</style>
